<!--
 * @Author: wsx
 * @Date: 2022-02-14 17:53:19
 * @LastEditTime: 2022-02-28 17:00:04
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE3
 * @FilePath: \hz-digital-twin\src\layout\index.vue
-->
<template>
  <div class="h-layout">
    <my-header @openMenu="openMenu"></my-header>
    <component :is="iscomponent"></component>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject, ref } from "vue";
import dataVisualization from "./components/dataVisualization.vue";
import dataAnalysis from "./components/dataAnalysis.vue";
import MyHeader from "./components/MyHeader/index.vue";

export default defineComponent({
  name: "Layout",
  components: { dataVisualization, MyHeader, dataAnalysis },
  props: {},
  setup() {
    const state = reactive({
      iscomponent: "dataVisualization"
    });

    const activeIndex = ref("1");
    const refData = toRefs(state);

    const socket = inject("socket");
    socket.initSocket();
    const openMenu = menu => {
      state.iscomponent = menu.path;
      console.log(menu.path, 6666);
    };
    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
    };
    return { ...refData, handleSelect, activeIndex, openMenu };
  }
});
</script>
<style lang="scss" scoped>
.h-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-image: url("~@/assets/images/index/bg.png");
  background-size: 100% 100%;
  // .my-main {
  //   flex: 1;
  //   width: 100%;
  // }
  // .my-footer {
  //   width: 100%;
  // }
}
</style>
